export class DownPayment {

    maxDownPayment:number;
    minDownPayment:number;
}